import { render, staticRenderFns } from "./BoardsListFilter.vue?vue&type=template&id=6a43e632&"
import script from "./BoardsListFilter.vue?vue&type=script&lang=js&"
export * from "./BoardsListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports